import { NgModule } from '@angular/core';
import 'hugerte';
import { EditorModule } from '@hugerte/hugerte-angular';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxRichTextEditorComponent } from './rich-text-editor.component';
import { CommonModule } from '@angular/common';

@NgModule({
	imports: [
		CommonModule,
		EditorModule,
		FormsModule,
		ReactiveFormsModule
	],
	declarations: [
		NgxRichTextEditorComponent
	],
	exports: [
		NgxRichTextEditorComponent
	]
})
export class NgxRichTextEditorModule {}
